import Vue from 'vue'
import { Component } from 'vue-property-decorator';
import NodeList from '@/components/common/Sidebar/NodeList.vue'
import NodeItem from '@/components/common/Sidebar/NodeItem.vue'
import { mapGetters } from 'vuex'
import * as accountTypes from '@account/store/types'

export interface MenuInfo {
    name: string
    id: Number
    icon: string
    select: boolean
    expand: boolean
    child?: MenuInfo[]
    path: string
    type: string
    targetUrl?: string | null
}

@Component({
    components: { NodeList, NodeItem },
    computed: {
        ...mapGetters({
            userCurrent: accountTypes.CURRENT
        })
    }
})
export default class WorkflowFolderList extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    userCurrent!: account.TCurrent

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    menuPermission: account.TPermissionMenu[] = []
    menus: MenuInfo[] = []

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    makeMenu(childItems: appbase.cache.TMenuItem[], parentMenu: MenuInfo) {
        this.menuPermission = this.userCurrent.permissions.menues
        childItems.forEach(item => {
            var menuItem: MenuInfo = {
                name: '',
                id: 0,
                icon:'folder',
                select: false,
                expand: false,
                path: 'workflow-list',
                type: 'router-link',
                child: [],
                targetUrl: ''
            }

            if (this.menuPermission.find((x) => x.id == item.menuId)) {
                var resourceId = ''
                //2024.07.31 YSJ Modified 타겟으로 연결된 리소스로 표시되어 메뉴로 표시되도록 수정
                /*
                if (item.targetUrl){
                    var dqn = item.targetUrl.split('dqn=')[1]
                    resourceId = 'W_DocumentList_' + dqn //W_DocumentList_1010
                } else {
                    resourceId = this.userCurrent.userConfig.language === 'ko-KR' ? item.menuName : item.menuNameEn
                }
                */

                resourceId = this.userCurrent.userConfig.language === 'ko-KR' ? item.menuName : item.menuNameEn
                menuItem.name = this.$t(resourceId).toString()
                menuItem.id = item.menuId
                menuItem.targetUrl = item.targetUrl

                parentMenu?.child?.push(menuItem)

                if (item.hasChildren) {
                    this.makeMenu(item.children, menuItem)
                }
            }
        })
    }

    created() {
        if (!this.menus.length) {
            const { menu } = this.portalCache
            this.menuPermission = this.userCurrent.permissions.menues
            var workflowMenu = menu.items.find(x => x.menuName == '전자결재' && x.menuType == 'TX')

            workflowMenu?.children.filter(x => x.isUseMobile).forEach(menu => {
                var menuItem: MenuInfo = {
                    name: '',
                    id: 0,
                    icon:'folder',
                    select: false,
                    expand: true,
                    path: 'workflow-list',
                    type: 'router-link',
                    child: [],
                    targetUrl: '' || null
                }

                if (this.menuPermission.find((x) => x.id == menu.menuId)) {
                    var resourceId = ''

                    //2024.07.31 YSJ Modified 타겟으로 연결된 리소스로 표시되어 메뉴로 표시되도록 수정
                    /*
                    if (menu.targetUrl){
                        var dqn = menu.targetUrl.split('dqn=')[1]
                        resourceId = 'W_DocumentList_' + dqn //W_DocumentList_1010
                    } else {
                        resourceId = this.userCurrent.userConfig.language === 'ko-KR' ? menu.menuName : menu.menuNameEn
                    }
                    */
                    resourceId = this.userCurrent.userConfig.language === 'ko-KR' ? menu.menuName : menu.menuNameEn

                    menuItem.name = this.$t(resourceId).toString()
                    menuItem.id = menu.menuId
                    menuItem.targetUrl = menu.targetUrl

                    this.menus.push(menuItem)

                    if (menu.hasChildren) {
                        this.makeMenu(menu.children, menuItem)
                    }
                }
            })
        }
    }
}